import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from '../../../internal/cx.js';
import { InfoGlyph, SuccessGlyph, WarningGlyph } from '../../../internal/icons.js';
const defaultIcon = {
    neutral: _jsx(InfoGlyph, {}),
    info: _jsx(InfoGlyph, {}),
    success: _jsx(SuccessGlyph, {}),
    warning: _jsx(WarningGlyph, {}),
    danger: _jsx(WarningGlyph, {}),
};
/** Inline message about the state of a page or section. */
export function Alert({ tone = 'info', title, icon, actions, live, className, children, ...rest }) {
    const role = live === 'assertive' ? 'alert' : live === 'polite' ? 'status' : undefined;
    const glyph = icon === undefined ? defaultIcon[tone] : icon;
    return (_jsxs("div", { ...rest, role: rest.role ?? role, className: cx('mn-alert', className), "data-tone": tone, children: [glyph ? (_jsx("span", { className: "mn-alert__icon", "aria-hidden": true, children: glyph })) : null, _jsxs("div", { className: "mn-alert__body", children: [title ? _jsx("p", { className: "mn-alert__title", children: title }) : null, children ? _jsx("div", { className: "mn-alert__content", children: children }) : null] }), actions ? _jsx("div", { className: "mn-alert__actions", children: actions }) : null] }));
}
//# sourceMappingURL=alert.js.map